<template>
  <div class="field is-flex is-justify-content-space-between">
    <small class="has-text-grey-light">{{ eligibilityParamText }}</small>
    <span
      class="tag is-light is-rounded"
      :class="eligibilityState.color">
      {{ eligibilityState.text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'EligibilityTag',
  props: {
    inverse: {
      type: Boolean,
      default: false
    },
    print:
    {
      type: Boolean,
      default: false
    },
    eligibilityParam: {
      type: [String, Number, Boolean, Object],
      default: '---'
    },
    eligibilityData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      eligibilityResult: null
    };
  },
  computed: {

    eligibilityState() {
      const states = {
        Approved: { text: 'Cumple', color: { 'is-primary': true } },
        Reviewable: { text: 'Revisar', color: { 'is-warning': true } },
        Refused: { text: 'No Cumple', color: { 'is-danger': true } }
      };
      return states[this.eligibilityData?.eligibility || this.eligibilityData?.result] || { text: 'No Definido', color: { 'is-danger': true } };
    },
    eligibilityParamText() {
      if (this.eligibilityParam === null || this.eligibilityParam === undefined) {
        return '---';
      }

      if (typeof this.eligibilityParam === 'boolean') {
        return this.eligibilityParam ? 'Sí' : 'No';
      }

      const result = this.eligibilityData?.eligibility || this.eligibilityData?.result;
      const isApproved = result === 'Approved';

      if (typeof this.eligibilityParam === 'number') {
        // return this.eligibilityParam.toLocaleString('es-CL');
        // TODO: debería mostrarse los valores
        if (this.print) {
          return this.eligibilityParam.toLocaleString('es-CL');
        }
        if (this.inverse) {
          return isApproved ? 'Sí' : 'No';
        }

        return isApproved ? 'No' : 'Sí';
      }

      if (typeof this.eligibilityParam === 'object') {
        if (this.inverse) {
          return isApproved ? 'Sí' : 'No';
        }

        return isApproved ? 'No' : 'Sí';
      }

      return this.eligibilityParam;
    }
  }

};
</script>
